import * as XLSX from "xlsx-js-style";

export const ProjectEnquiryExcel = (data = []) => {
  if (!Array.isArray(data) || data.length === 0) return;

  const wb = XLSX.utils.book_new();
  const ws = XLSX.utils.aoa_to_sheet([]);

  /* ================= TITLE (A1) ================= */
  XLSX.utils.sheet_add_aoa(ws, [["Project Enquiry"]], { origin: "A1" });

  ws["A1"].s = {
    font: { bold: true, sz: 16 },
    alignment: { horizontal: "center", vertical: "center" },
    fill: { fgColor: { rgb: "BDD7EE" } },
  };

  // Merge A1 → I1 (9 columns)
  ws["!merges"] = [
    { s: { r: 0, c: 0 }, e: { r: 0, c: 8 } },
  ];

  ws["!rows"] = [{ hpt: 30 }];

  /* ================= TABLE HEADER (A3) ================= */
  const tableHeaderRow = 2;

  const tableHeaders = [
    "SL#",
    "Project",
    "Milestone",
    "Operation",
    "Activities",
    "Task Date",
    "Task Description",
    "Scheduled To",
    "Status",
  ];

  XLSX.utils.sheet_add_aoa(ws, [tableHeaders], { origin: "A3" });

  const headerStyle = {
    font: { bold: true },
    alignment: { horizontal: "center", vertical: "center", wrapText: true },
    fill: { fgColor: { rgb: "EEF3FB" } },
    border: {
      top: { style: "thin" },
      bottom: { style: "thin" },
      left: { style: "thin" },
      right: { style: "thin" },
    },
  };

  // Apply header style to ALL 9 columns
  for (let c = 0; c < tableHeaders.length; c++) {
    ws[XLSX.utils.encode_cell({ r: tableHeaderRow, c })].s = headerStyle;
  }

  /* ================= TABLE DATA (A4+) ================= */
  const tableData = data.map((row, index) => [
    index + 1,
    row.Project || "",
    row.Milestone || "",
    row.OperationStage || "",
    row.Activites || "",
    row.ProjectPlanDate || "",
    row.Task || "",
    row.ScheduledToName || "",
    row.Status || "",
  ]);

  const tableStartRow = tableHeaderRow + 1;

  XLSX.utils.sheet_add_aoa(ws, tableData, { origin: "A4" });

  const range = XLSX.utils.decode_range(ws["!ref"]);

  const oddRowStyle = {
    fill: { fgColor: { rgb: "FFFFFF" } },
  };

  const evenRowStyle = {
    fill: { fgColor: { rgb: "EEF3FB" } },
  };

  /* ================= ROW STYLING ================= */
  for (let R = tableStartRow; R <= range.e.r; R++) {
    const baseStyle = R % 2 === 0 ? evenRowStyle : oddRowStyle;

    for (let C = 0; C < tableHeaders.length; C++) {
      const cell = XLSX.utils.encode_cell({ r: R, c: C });
      if (!ws[cell]) continue;

      ws[cell].s = {
        ...baseStyle,
        alignment: {
          horizontal: C === 0 ? "center" : "left",
          vertical: "center",
          wrapText: true,
        },
        border: {
          top: { style: "thin" },
          bottom: { style: "thin" },
          left: { style: "thin" },
          right: { style: "thin" },
        },
      };
    }
  }

  /* ================= COLUMN WIDTHS (9 COLUMNS) ================= */
  ws["!cols"] = [
    { wch: 4 },   // SL#
    { wch: 20 },  // Project
    { wch: 18 },  // Milestone
    { wch: 18 },  // Operation
    { wch: 22 },  // Activities
    { wch: 10 },  // Task Date
    { wch: 50 },  // Task Description
    { wch: 22 },  // Scheduled To
    { wch: 12 },  // Status
  ];

  /* ================= EXPORT ================= */
  XLSX.utils.book_append_sheet(wb, ws, "Project Enquiry");
  XLSX.writeFile(wb, "Project_Enquiry.xlsx");
};

export default ProjectEnquiryExcel;
